<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.product_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <piaf-breadcrumb heading="Products List"/>

        <div class="d-flex flex-row">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,
                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum
                officiis quia quos rem totam vitae.
            </p>
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchProduct" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'Products List'">

            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchProducts">
                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(name)="data">
                     <span @click="productDetails(data.item)" style="cursor: pointer;" class="text-data-link"
                           v-text="data.item.data.attributes.name"/>
                </template>

                <template v-slot:cell(brand)="data">
                    <span v-text="data.item.data.attributes.brand"/>
                </template>

                <template v-slot:cell(category)="data">
                    <span v-text="data.item.data.attributes.category"/>
                </template>

                <template v-slot:cell(sub_category)="data">
                    <span v-text="data.item.data.attributes.sub_category"/>
                </template>

                <template v-slot:cell(expires_on)="data">
                    <span v-text="data.item.data.attributes.expires_on"/>
                </template>

                <template v-slot:cell(unit)="data">
                    <span v-text="data.item.data.attributes.unit"/>
                </template>

                <template v-slot:cell(usaage_unit)="data">
                    <span v-text="data.item.data.attributes.usage_unit"/>
                </template>

                <template v-slot:cell(purchase_unit)="data">
                    <span v-text="data.item.data.attributes.purchase_unit"/>
                </template>

                <template v-slot:cell(cost)="data">
                    <span v-text="data.item.data.attributes.cost"/>
                </template>

                <template v-slot:cell(alert_quantity)="data">
                    <span v-text="data.item.data.attributes.alert_quantity"/>
                </template>

                <template v-slot:cell(opening_stock)="data">
                    <span v-text="data.item.data.attributes.opening_stock"/>
                </template>

                <template v-slot:cell(image)="data">
                    <span v-text="data.item.data.attributes.image"/>
                </template>

                <template v-slot:cell(details)="data">
                    <span v-text="data.item.data.attributes.details"/>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>

                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item @click="editProduct(data.item.product_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteProduct(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <ProductFormModal :edit="edit" @updated="tableKey++"/>

        <ProductDeleteModal v-if="product" :product="product" @updated="tableKey++"/>

    </div>
</template>

<script>
import _ from 'lodash';
    import {mapGetters} from "vuex";
    import ProductFormModal from "./modals/ProductFormModal";
    import ProductDeleteModal from "./modals/ProductDeleteModal";

    export default {
        name: "ProductsList",

        components: {
            ProductFormModal,
            ProductDeleteModal,
        },

        data() {
            return {
                loading: false,
                edit: false,
                tableKey: 0,
                product: null,
            }
        },

        computed: {
            ...mapGetters({
                table_fields: 'getProductTableFields',
                meta: 'getProductMeta'
            })

        },

        methods: {
            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            searchProduct: _.debounce(function (event) {
                if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                }
            }, 300),

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            refreshData() {
                this.$store.commit('resetProductsMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            fetchProducts() {
                return this.$store.dispatch('fetchProducts')
                    .then(billings => {
                        return billings.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            productDetails(product) {
                this.product = product;

                setTimeout(() => {
                    this.$bvModal.show('details');
                }, 1);
            },

            editProduct(product_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditProduct', product_id)
                    .finally(response => {
                        this.$bvModal.show('product_form');
                    });
            },

            deleteProduct(product) {
                this.product = product;

                setTimeout(() => {
                    this.$bvModal.show('product_delete');
                }, 1);
            },
        },

    }
</script>

<style scoped>

</style>
